import {
  axiosPostCall,
  axiosGetCall,
  axiosPatchCall,
} from "../utils/AxiosCalls.js";

export const jwtRegister = async (url, payload, authToken) => {
  return axiosPostCall(url, payload, authToken);
};

export const jwtLogin = async (url, payload) => {
  return axiosPostCall(url, payload);
};

export const jwtConfirmEmail = async (url, token) => {
  return axiosGetCall(url, { token });
};

export const jwtResetPassword = async (url, email) => {
  return axiosGetCall(url, { email });
};

export const jwtChangePassword = async (url, payload) => {
  return axiosPostCall(url, payload);
};

export const jwtGetUserProfile = async (url, payload, authToken) => {
  return axiosGetCall(url, payload, authToken);
};

export const jwtUpdateUserProfile = async (url, payload, authToken) => {
  return axiosPatchCall(url, payload, authToken);
};
